import { render, staticRenderFns } from "./EducationalRatingCards.vue?vue&type=template&id=46ccda13&"
import script from "./EducationalRatingCards.vue?vue&type=script&lang=js&"
export * from "./EducationalRatingCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports